import { useEffect, useState } from 'react';
import { getDateString, getDateStringShort } from 'helpers/date';

interface DateStringProps {
  date: string;
  short?: boolean;
}

export default function DateString({ date, short = false }: DateStringProps) {
  const [dateString, setDateString] = useState<string>();

  useEffect(() => {
    setDateString(short ? getDateStringShort(date) : getDateString(date));
  }, [date, short]);

  return <span dangerouslySetInnerHTML={!dateString ? { __html: '&nbsp;'.repeat(short ? 6 : 10) } : undefined}>{dateString}</span>;
}
